console.log('common');
let scrollYOld = 0;

function copyright() {
    console.info('%cCode - https://matthieurenaut.com', 'background: #000; border: 2px solid #fff; padding: 15px; color: #fff; font-size: .8rem;');
}

function reveal() {
    const blocksReveal = document.querySelectorAll('.reveal');

    const observer = new IntersectionObserver(
        items =>
            items.forEach(e => {
                if (e.isIntersecting) {
                    e.target.classList.add('show');
                }
            }),
        {
            // root: document.querySelector('#scrollArea'),
            // rootMargin: '0px',
            threshold: 0.25,
        },
    );

    blocksReveal.forEach(block => {
        observer.observe(block);
    });
}

function handleScroll() {
    const scrollY = window.pageYOffset || window.scrollY;

    document.querySelector('.main-header').classList[scrollYOld > scrollY ? 'remove' : 'add']('hide');
    document.querySelector('.main-header').classList[scrollYOld > scrollY ? 'add' : 'remove']('fixed');

    if (scrollY === 0) {
        document.querySelector('.main-header').classList.remove('fixed', 'hide');
    }

    scrollYOld = scrollY;
}

window.addEventListener('scroll', handleScroll);

reveal();
copyright();
